import Icon from '@material-ui/icons/Event';
import React from 'react';
import { SimpleShowLayout } from 'react-admin';
import { CreateButton } from '../../../buttons';
import { EditDialog, Filter, NestedResourceList, ResourceList, ResourceShow } from '../../../controllers';
import { BookingStatusField, DateField, DateTimeField, EnumField, LinkField, StartAndEndTimeField, TextField } from '../../../fields';
import { ArrayOfStringsInput, BookingScheduleInput, BooleanInput, DateInput, EnumInput, NestedReferenceInput, SearchInput, TimeZoneSelectInput } from '../../../inputs';
import attendances from './attendances';


export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <DateInput
          source="first_visit_at"
        />
        {props.record.last_visit_at && props.record.status != 'held' ? (
          <DateField
            source="last_visit_at"
          />
          ):(
            <DateInput
              source="last_visit_at"
            />
          )}
        <StartAndEndTimeField />
        <ArrayOfStringsInput
          source="excluded_dates"
        />
        <EnumInput
          source="completed_reason"
        />
        <NestedReferenceInput
          source="subscription_id"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ organization_id: props.parentResource.id }}
        {...props}
      >
        <NestedReferenceInput
          filter={{ scope: 'child' }}
          filterToQuery={searchText => ({ name: searchText })}
          source="user_id"
        />
        <BookingScheduleInput />
        <ArrayOfStringsInput
          source="excluded_dates"
        />
        <TimeZoneSelectInput />


      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <LinkField
          source="user_id"
        />
        <LinkField
          source="location_id"
        />
        <LinkField
          source="occasion_id"
        />
        <DateField
          source="first_visit_at"
        />
        <DateField
          source="last_visit_at"
        />
        <EnumField
          source="weekday_name"
        />
        <StartAndEndTimeField />
        <BookingStatusField />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <LinkField
          source="user_id"
        />
        <LinkField
          source="location_id"
        />
        <LinkField
          source="occasion_id"
        />
        <TextField
          source="first_visit_at"
        />
        <TextField
          source="last_visit_at"
        />
        <StartAndEndTimeField />
        <EnumField
          source="status"
        />
        <TextField
          source="completed_reason"
        />
        <TextField
          source="excluded_dates"
        />
        <NestedResourceList
          reference="attendances"
        >
          <DateField
            source="date"
          />
          <LinkField
            label="Booking"
            parentReference="organizations"
            parentSource="_meta_organization_id"
            reference="bookings"
            source="booking_id"
          >
            <StartAndEndTimeField />
          </LinkField>
          <LinkField
            label="User"
            parentReference="organizations"
            parentSource="_meta_organization_id"
            reference="users"
            source="_meta_user_id"
          />
          <EnumField
            source="status"
          />
          <DateTimeField
            source="check_in_at"
          />
        </NestedResourceList>
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
        <EnumInput
          source="status"
        />
        <NestedReferenceInput
          source="user_id"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
    Expand: props => (
      <SimpleShowLayout
        {...props}
      >
        <EnumField
          source="weekday_name"
        />
        <TextField
          source="excluded_dates"
        />
        <TextField
          source="completed_reason"
        />
      </SimpleShowLayout>
    ),
  },
  resources: {
    attendances,
  },
};
